module.exports = __webpack_public_path__ + "static/media/gaizao-shiweidangxiao.54869bad.jpg";